module.exports={render:function (){with(this) {
  return _h('div', {
    staticClass: "overlay"
  }, [_h('div', {
    staticClass: "overlay-content"
  }, [_h('a', {
    staticClass: "overlay-close",
    attrs: {
      "href": "#"
    },
    on: {
      "click": back
    }
  }, ["✕"]), " ", _m(0)])])
}},staticRenderFns: [function (){with(this) {
  return _h('div', {
    staticClass: "overlay-inner"
  }, [_h('h2', ["Corporate Innovation"]), " ", _h('p', ["We deeply believe in the power of world-changing ", _h('span', {
    staticClass: "versa"
  }, ["INNOVATION"]), ". Especially the ", _h('span', {
    staticClass: "versa"
  }, ["CLEANTECH"]), " sector has proven in\n        recent years, that it is possible to change the world with innovation through its enormous success of\n        improving ", _h('span', {
    staticClass: "versa"
  }, ["PHOTOVOLTAIK"]), " and ", _h('span', {
    staticClass: "versa"
  }, ["WIND"]), " power products while decreasing its costs massively.\n        Therefore we try to live innovation every day, by constantly scrutinizing the current state of mind and\n        continuously working on improving a given system. To make innovation become reality we apply proven methods\n        and explore new paths to support the development of new processes, ideas or products. Thereby ", _h('span', {
    staticClass: "versa"
  }, ["START-UPS"]), " can\n        very well complement the innovation portfolio of ", _h('span', {
    staticClass: "versa"
  }, ["CORPORATIONS"]), "."]), " ", _h('p', [" We provide the following services to boost your innovation capabilities and transform your business for a ", _h('span', {
    staticClass: "versa"
  }, ["GREEN"]), " future:\n      "]), " ", _h('ul', [_h('li', ["Strategic Foresight (Innovation Radar and Strategic Roadmapping)"]), " ", _h('li', ["Innovation Exploration and corporate/ start-up matching"]), " ", _h('li', ["Start-up scouting and evaluation"]), " ", _h('li', ["Innovation Contests and Hackathons"]), " ", _h('li', ["Intrapreneurship and Accelerator programs"])]), " ", _h('h2', ["Corporate project activity"]), " ", _h('ul', {
    staticClass: "years"
  }, [_h('li', [_h('span', ["2015"]), _h('a', {
    attrs: {
      "href": "//www.rohrbeckheger.com/work/innovation-exploration/",
      "target": "_blank"
    }
  }, ["Innovation Exploration"]), " for a major corporate"]), " ", _h('li', [_h('span', ["2015"]), "IT tool based innovation radar for a major corporate in the energy and resource sector\n        "]), " ", _h('li', [_h('span', ["2014"]), "Co-organization of a ", _h('a', {
    attrs: {
      "href": "//www.laboratories.telekom.com/public/deutsch/newsroom/news/pages/t-labs-verleihen-sonderpreis-smart-energy-fuer-whats-my-carbon.aspx",
      "target": "_blank"
    }
  }, ["Hackathon"]), " with Berlin ", _h('a', {
    attrs: {
      "href": "//www.geekettes.io/",
      "target": "_blank"
    }
  }, ["Geekettes"]), " for SAP"]), " ", _h('li', [_h('span', ["2013"]), "Development and organization of a innovation contest for a large corporate"]), " ", _h('li', [_h('span', ["2012"]), _h('a', {
    attrs: {
      "href": "//papers.ssrn.com/sol3/papers.cfm?abstract_id=2197724",
      "target": "_blank"
    }
  }, ["Smart Energy Working Group"]), " workshop based development of new business models with 8\n          utilities\n        "]), " ", _h('li', [_h('span', ["2011"]), "Innovation Radar Energy for a major utility"])]), " ", _h('p', {
    staticClass: "end"
  })])
}}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d6c497ec!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Corporate.vue
// module id = 40
// module chunks = 1